import { Injectable, inject } from "@angular/core";
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, switchMap } from 'rxjs/operators';
import { loadWorkspaceLicenses, loadWorkspaceLicensesFailed, loadWorkspaceLicensesSuccess } from "../actions/workspace-licenses.action";
import { WorkspaceLicensesService } from "src/app/services/workspace-licenses/workspace-licenses.service";

@Injectable()
export class WorkspaceLicensesEffects {
	private actions$ = inject(Actions);
	private userLicensesService = inject(WorkspaceLicensesService);


	// Load the workspace licenses of the workspace
	loadUserLicense$ = createEffect(() => this.actions$.pipe(
		ofType(loadWorkspaceLicenses),
		switchMap(() =>
			this.userLicensesService.loadWorkspaceLicenses().pipe(
				map(resp => loadWorkspaceLicensesSuccess({ licenses: resp.data })),
				catchError(async (error) => loadWorkspaceLicensesFailed({ error: error }))
			)
		)
	));

}
